// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanRevokeRegistrationToken } from "./hook";

export type CanRevokeRegistrationTokenProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanRevokeRegistrationToken({
  children,
  fallback,
  scope,
}: CanRevokeRegistrationTokenProps) {
  const canDoAction = useCanRevokeRegistrationToken(scope);
  return <>{canDoAction ? children : fallback}</>;
}
